exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".map-component{width:100%;height:100vh}.map-component .map{height:94%;background-color:#fff;margin-top:-10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/MapDetail.scss
// module id = 647
// module chunks = 0